import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ORDER_ONLINE_URL } from "../lib/links";

/**
 * Sticky mobile-only CTA bar.
 *
 * Hidden on:
 *   - /order (we're already on the ordering flow)
 *   - /crm/* (internal staff CRM)
 *   - when near the top of the page (so it doesn't duplicate the hero CTA)
 */
export default function MobileOrderBar() {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/order") || pathname.startsWith("/crm")) return null;
  if (!show) return null;

  return (
    <div className="md:hidden fixed bottom-4 left-4 right-4 z-40" data-testid="mobile-sticky-cta">
      <a
        href={ORDER_ONLINE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-pill w-full bg-[#C8102E] text-[#F7F5F0] shadow-[0_18px_40px_rgba(200,16,46,0.35)]"
      >
        Order Online <ArrowUpRight className="h-4 w-4" />
      </a>
    </div>
  );
}
